document.addEventListener("DOMContentLoaded", () => {
  const contactForms = document.querySelectorAll(".contact-form");

  if (contactForms.length > 0) {
    contactForms.forEach((form) => {
      const nameInput = form.querySelector('[name="contact[name]"');
      const emailInput = form.querySelector('[name="contact[email]"');
      const messageInputContainer = form.querySelector("#message-input");
      const validationBox = form.querySelector("#validation-box");

      form.addEventListener("ajax:success", showSuccessMessage);
      form.addEventListener("ajax:error", showErrorMessage);

      const toggleMessageInputContainer = () => {
        if (!messageInputContainer) return;

        if (
          emailInput.validationMessage === "" &&
          nameInput.value.trim() !== "" &&
          emailInput.value.trim() !== ""
        ) {
          messageInputContainer.classList.remove("hidden");
        }
      };

      if (nameInput) {
        nameInput.addEventListener("input", toggleMessageInputContainer);
      }

      if (emailInput) {
        emailInput.addEventListener("input", toggleMessageInputContainer);
      }

      // Waitlist-style forms (show_message: false in the shared/contact
      // partial) submit a fixed hidden message instead of a textarea. Append
      // the visible version/CI choice to it, because the Slack and HubSpot
      // notifications only show the message, not the version column.
      const hiddenMessage = form.querySelector(
        'input[type="hidden"][name="contact[message]"]'
      );
      const versionSelect = form.querySelector(
        'select[name="contact[version]"]'
      );
      if (hiddenMessage && versionSelect) {
        const baseMessage = hiddenMessage.value;
        const syncMessage = () => {
          hiddenMessage.value = `${baseMessage} (${versionSelect.value})`;
        };
        syncMessage();
        versionSelect.addEventListener("change", syncMessage);
      }

      const otherReferral = form.querySelector("#other_referral");
      const foundUsSource = form.querySelector("#found-us-source");
      const foundUs = form.querySelector("#found_us");
      const referrals = form.querySelector("#referrals");

      // The compact form variant (e.g. the Staff Augmentation page) omits the
      // "How did you find us?" controls and submits a fixed value instead, so
      // only wire up this block when those elements are present.
      if (foundUs && foundUsSource && otherReferral && referrals) {
        const updateFoundUs = (source = "") => (foundUs.value = source);
        updateFoundUs("Google");

        otherReferral.addEventListener("input", (event) => {
          updateFoundUs(event.target.value);
        });

        referrals.addEventListener("change", (event) => {
          updateFoundUs(event.target.value);
        });

        const referralsVisibility = (other_referral, referral) => {
          document.getElementById("other-referrals-input-div").hidden =
            other_referral;
          document.getElementById("referrals-input-div").hidden = referral;
        };

        foundUsSource.addEventListener("change", (event) => {
          const source = event.target.value;
          if (source == "Other") {
            updateFoundUs(otherReferral.value);
            referralsVisibility(false, true);
          } else if (source == "Referral") {
            updateFoundUs(referrals.value);
            referralsVisibility(true, false);
          } else {
            referralsVisibility(true, true);
            updateFoundUs(source);
          }
        });
      }
    });
  }

  function showSuccessMessage(event) {
    const form = event.target;

    const validationBox = form.querySelector("#validation-box");
    validationBox.classList.remove("expand");
    document
      .querySelectorAll("div#contact-us > .contact-us--col")
      .forEach((element) => {
        element.classList.add("shrink");
      });

    const popupHeader = form.querySelector("#contact-us-popup h1");
    if (popupHeader) {
      popupHeader.innerHTML = "Cheers!";
    }

    // Forms can override the generic copy via data-success-message (set by
    // the shared/contact partial's success_message local).
    const successMessage =
      form.dataset.successMessage ||
      "Thank you! We will get back to you soon ;-) ";
    validationBox.innerHTML =
      '<div class="form-success" id="contact-success-wrapper"></div>';
    validationBox.firstChild.textContent = successMessage;
    validationBox.focus();
    validationBox.classList.add("expand");

    // Disabled: not running LinkedIn ads currently
    // const emailInput = form.querySelector('[name="contact[email]"');
    // if (!emailInput.value.includes("@ombulabs.com")) {
    //   const linkedin = "1510041";
    //
    //   conversionTracking(linkedin);
    // }
  }

  function showErrorMessage(event) {
    const form = event.target;

    const validationBox = form.querySelector("#validation-box");
    validationBox.classList.remove("expand");

    const formError = form.querySelector(".form-error");
    if (formError) {
      formError.remove();
    }
    var msg =
      '<div class="form-error"><p><i class="fa fa-exclamation-triangle"></i> There was a problem: ' +
      event.detail[0] +
      "</p></div>";
    validationBox.focus();
    validationBox.innerHTML = msg;
    validationBox.classList.add("expand");
  }
});
